import { stateAbbreviationResolver } from "../../../data/utils/stateUtil";

export const getNormalizedValue = (value, type) => {
  switch (type) {
    case "string":
      return `${value}`;
    case "bool":
      return value ? "YES" : "NO";
    case "number":
      return isNaN(value) ? "0" : value;
    case "per":
      const perMapping = {
        Hourly: "Hour",
        Weekly: "Week",
        Biweekly: "Bi-weekly",
        Monthly: "Month",
        Annual: "Year",
      };
      return perMapping[value] || "N/A";
    case "wageNumToString":
      return value
        ? parseFloat(value).toLocaleString("en", {
            useGrouping: false,
            minimumFractionDigits: 2,
          })
        : null;
    case "state":
      return stateAbbreviationResolver(value) || undefined;
    default:
      return value;
  }
};
